import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/blog/components/BlogContent.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/homepage/styles/home2.module.css");
